import Palettizer from './Palettizer.component';

export default Palettizer;
